import { StyleSheet, TouchableOpacity, View } from "react-native";
import { usePagination } from "react-instantsearch-hooks";

import { kStyleConst } from "src/kStyle";
import { PdIconButton } from "./forms/icon-button";
import { PdArrowLeft, PdArrowRight } from "./Icons";
import { PdText } from "./layout";

const SearchPagination: React.FC<{ onPress?: () => void }> = ({ onPress }) => {
  const { currentRefinement, refine, pages, isFirstPage, isLastPage } = usePagination();

  return (
    <View style={[styles.flexRow, styles.alignCenter, styles.justifyEnd]}>
      <PdIconButton
        variant="ghost"
        icon={<PdArrowLeft style={styles.widthMd} />}
        onPress={() => {
          refine(currentRefinement - 1);
          onPress?.();
        }}
        isDisabled={isFirstPage}
      />
      {pages.map((page) => (
        <TouchableOpacity
          key={page}
          style={styles.px2}
          onPress={() => {
            refine(page);
            onPress?.();
          }}
          disabled={page === currentRefinement}
        >
          <PdText style={page === currentRefinement ? styles.textBold : {}}>{page + 1}</PdText>
        </TouchableOpacity>
      ))}
      <PdIconButton
        variant="ghost"
        icon={<PdArrowRight style={styles.widthMd} />}
        onPress={() => {
          refine(currentRefinement + 1);
          onPress?.();
        }}
        isDisabled={isLastPage}
      />
    </View>
  );
};

export default SearchPagination;

const styles = StyleSheet.create({
  alignCenter: {
    alignItems: "center",
  },
  flexRow: {
    flexDirection: "row",
  },
  justifyEnd: {
    justifyContent: "flex-end",
  },
  px2: {
    paddingHorizontal: 2 * kStyleConst.kSpacing,
  },
  textBold: {
    fontWeight: "500",
  },
  widthMd: {
    width: 20,
  },
});
